import { handleError } from "../Helpers/ErrorHandler";
import {
  PreviewSummary,
  RefCode,
  RefCodeType,
  ReferenceCodesParam,
} from "../Models/ReferenceCodes";
import axiosInstance from "./Axios";

export const postReferenceCodes = async (
  referenceCodesParam: ReferenceCodesParam
) => {
  try {
    const endpoint = formatUrl("/checkout/pre", referenceCodesParam);
    const response = await axiosInstance.get<RefCode>(endpoint);
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

export const getPreviewSummary = async (
  referenceCodesParam: ReferenceCodesParam
) => {
  try {
    if (referenceCodesParam.type === RefCodeType.SNOOZE) { return; }
    const endpoint = formatUrl("/checkout/preview", referenceCodesParam);
    const response = await axiosInstance.get<PreviewSummary>(endpoint);
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

export const formatUrl = (
  path: string,
  referenceCodesParam: ReferenceCodesParam
) => {
  const params = new URLSearchParams({
    type: referenceCodesParam.type.toString(), // type parametresi dinamik olarak alınıyor
  });

  if (referenceCodesParam.creditId) {
    params.append("creditId", referenceCodesParam?.creditId.toString());
  }

  return `${path}?${params.toString()}`;
};
